import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";
import { eduMap } from "../assets/educationImages/educationImages";

import EducationDegree from "./EducationDegree";
import CertificationsList from "./EducationCerts";
import SuperbadgesList from "./EducationSuperbadges";

export default function Education() {
    // const [education, setEducation] = useState([]);

    // useEffect(() => {
    //     const fetchEducation = async () => {
    //     try {
    //         const educationRef = collection(db, "education");
    //         const snapshot = await getDocs(educationRef);

    //         const educationData = snapshot.docs.map((doc) => ({
    //         id: doc.id,
    //         ...doc.data(),
    //         }));

    //         setEducation(educationData);
    //     } catch (err) {
    //         console.error("Error fetching education:", err);
    //     }
    //     };

    //     fetchEducation();
    // }, []);
    return (
    <section>
        <h2>Education</h2>
            <div className="educationWrapper">
                <EducationDegree />
            {/* <div className="educationInnerBody">
                {education.length === 0 ? (
                    <p>Loading education...</p>
                ) : (
                    education.map((item) => (
                    <div key={item.id} className="educationItem card">
                        <div>
                            <h3>{item.degree} - {item.school}</h3>
                            <div className="educationCard">
                                <div className="educationImage">
                                    <img
                                        src={eduMap[item.degreeName] || null}
                                        alt={item.degree}
                                    />
                                </div>
                                <div className="educationDetails">
                                    <p>{item.degree}, {item.major}, {item.minor}</p>
                                    <p className="educationYears">{item.years}</p>
                                    <p>{item.details}</p>
                                </div>
                                <div className="educationClasses">
                                    Classes: 
                                    {item.classes && item.classes.length > 0 && (
                                        <ul>
                                            {item.classes
                                                .filter(point => point && point.trim() !== "")
                                                .map((point, index) => (
                                                <li key={index}>{point}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div> 
                        </div>
                    </div>
                    ))
                )}
            </div> */}
            <div className="educationContinued">
                <SuperbadgesList />
                <CertificationsList />
                
            </div>
        </div>
    </section>
  )
}